const extractJwt = (tokenString) => {
  const parts = tokenString.split(' ')
  if (parts.length === 2 && parts[0] === 'Token') {
    return parts[1]
  }
  return null
}

const tokenVerification = (token) => {
  const jwtPattern = /^([a-zA-Z0-9\-_]+)\.([a-zA-Z0-9\-_]+)\.([a-zA-Z0-9\-_]+)$/
  return jwtPattern.test(extractJwt(token)
  )
}

export default tokenVerification
